module.exports = __webpack_public_path__ + "img/home-block-6-7.9be675ba.png";